import { useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from './Sidebar'
import TopNav from './TopNav'
import './DashboardLayout.css'

function DashboardLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false)
  const location = useLocation()

  const toggleSidebar = () => setSidebarCollapsed(!sidebarCollapsed)
  const toggleMobileSidebar = () => setMobileSidebarOpen(!mobileSidebarOpen)

  return (
    <div className={`dashboard-layout ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <Sidebar 
        collapsed={sidebarCollapsed} 
        mobileOpen={mobileSidebarOpen}
        onMobileClose={() => setMobileSidebarOpen(false)}
      />
      
      <div className="dashboard-main">
        <TopNav 
          onMenuClick={toggleMobileSidebar}
          onCollapseClick={toggleSidebar}
          collapsed={sidebarCollapsed}
        />
        
        <main className="dashboard-content">
          <Outlet />
        </main>
      </div>

      {/* Mobile overlay */}
      {mobileSidebarOpen && (
        <div 
          className="mobile-overlay" 
          onClick={() => setMobileSidebarOpen(false)}
          aria-hidden="true"
        />
      )}
    </div>
  )
}

export default DashboardLayout
